import { render, staticRenderFns } from "./NewYorkCityPropertyTaxes.vue?vue&type=template&id=4491934a&scoped=true&"
import script from "./NewYorkCityPropertyTaxes.vue?vue&type=script&lang=js&"
export * from "./NewYorkCityPropertyTaxes.vue?vue&type=script&lang=js&"
import style0 from "./NewYorkCityPropertyTaxes.vue?vue&type=style&index=0&id=4491934a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4491934a",
  null
  
)

export default component.exports